<template>
  <v-layout>{{ computedValue }}</v-layout>
</template>

<script>
export default {
  name: "SwitchColumn",
  props: ["entity_type", "entity", "column", "value"],
  computed: {
    computedValue() {
      if (this.value) return "Да";
      else return "Нет";
    }
  }
};
</script>

<style scoped></style>
